import React, { Component } from 'react'


export default class VideoList extends Component {
  render() {
    return (
      <div className="row videos-list">
        { this.props.children }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/VideoList.js